import { Component, Inject } from '@angular/core';
import { DialogResult } from '../../models/enums/dialog-result/dialog.result';
import { MatIconRegistry } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-session-expired-dialog',
    templateUrl: './session-expired-dialog.component.html',
    styleUrls: ['./session-expired-dialog.component.scss'],
    standalone: false
})
export class SessionExpiredDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SessionExpiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    protected iconRegistry: MatIconRegistry,
  ) {
  }

  onClsBtnClick(): void {
    this.dialogRef.close(DialogResult.CLOSED);
  }
}
